<template>
  <div class="seollal">
    <div class="first_page" v-if="page==1">
        <div class="first_page__back">
            <img src="@/assets/seollal/background.png">
        </div>
        <div class="first_page__logo">
            <img src="@/assets/seollal/logo.png">
        </div>
        <div class="first_page__title">
            <img src="@/assets/seollal/title.png">
        </div>
        <div class="first_page__btn" v-on:click="choiceVerse()">
            <img src="@/assets/seollal/start.png">
        </div>
        <div class="first_page__bottom_img">
            <img class="grass" src="@/assets/seollal/rabit.png"/>
        </div>
    </div>
    <div class="second_page" v-if="page==2">
        <div class="second_page__back">
            <img src="@/assets/seollal/background.png">
        </div>
        <div class="second_page__title">
            <img src="@/assets/seollal/title2.png">
        </div>
        <div class="second_page__ticket">
            <img src="@/assets/seollal/ticket.png">
            <div class="second_page__pocket">
                <img src="@/assets/seollal/pocket.png">
            </div>
            <div class="second_page__txt">
                <img src="@/assets/seollal/loading.png">
            </div>
            <div class="second_page__logo">
                <img src="@/assets/seollal/logo.png">
            </div>
        </div>
        <div class="second_page__bottom_img">
            <img class="grass" src="@/assets/seollal/rabit.png"/>
        </div>
    </div>
    <div class="third_page" v-if="page==3">
        <div class="third_page__back">
            <img src="@/assets/seollal/background.png">
        </div>
        <div class="third_page__pocket">
            <img src="@/assets/seollal/open_pocket.png"/>
        </div>
        <div class="third_page__transform_area" :class="scroll?'on':''">
            <div class="capture_area">
                <div class="third_page__title2">
                    <img src="@/assets/seollal/title2.png">
                </div>
                <div class="capture_area__back">
                    <img src="@/assets/seollal/background.png">
                </div>
                <div class="third_page__ticket">
                    <img src="@/assets/seollal/ticket.png">
                     <div class="capture_area__verse">
                        <p class="capture_area__verse_txt">{{print_verse.verse}}</p>
                        <p class="capture_area__verse_tit">{{print_verse.chapter}}</p>
                    </div>
                </div>
                 <div class="capture_area__arrow" v-on:click="scrollClick()">
                    <img src="@/assets/seollal/click.png">
                </div>
                <div class="third_page__flower">
                    <img src="@/assets/seollal/flower/1.png" class="f1">
                    <img src="@/assets/seollal/flower/2.png" class="f2">
                    <img src="@/assets/seollal/flower/3.png" class="f3">
                    <img src="@/assets/seollal/flower/4.png" class="f4">
                    <img src="@/assets/seollal/flower/5.png" class="f5">
                    <img src="@/assets/seollal/flower/6.png" class="f6">
                    <img src="@/assets/seollal/flower/7.png" class="f7">
                    <img src="@/assets/seollal/flower/8.png" class="f8">
                    <img src="@/assets/seollal/flower/9.png" class="f9">
                    <img src="@/assets/seollal/flower/10.png" class="f10">
                    <img src="@/assets/seollal/flower/11.png" class="f11">
                    <img src="@/assets/seollal/flower/12.png" class="f12">
                    <img src="@/assets/seollal/flower/13.png" class="f13">
                    <img src="@/assets/seollal/flower/14.png" class="f14">
                    <img src="@/assets/seollal/flower/15.png" class="f15">
                    <img src="@/assets/seollal/flower/16.png" class="f16">
                    <img src="@/assets/seollal/flower/17.png" class="f17">
                    <img src="@/assets/seollal/flower/18.png" class="f18">
                    <img src="@/assets/seollal/flower/19.png" class="f19">
                    <img src="@/assets/seollal/flower/20.png" class="f20">
                </div>
                <div class="third_page__bottom_img">
                    <img class="grass" src="@/assets/seollal/rabit.png"/>
                </div>
            </div>
            <div class="menu_area">
                <div class="menu_area__back">
                    <img src="@/assets/seollal/background.png">
                </div>
                 <div class="third_page__title">
                    <img src="@/assets/seollal/title.png">
                </div>
                 <ul class="menu_area__list">
                    <li class="menu_area__item">
                        <img src="@/assets/seollal/more.png" v-on:click="choiceVerse()"/>
                    </li>
                    <li class="menu_area__item">
                        <img src="@/assets/seollal/copy.png" v-on:click="shareClick()"/>
                    </li>
                    <li class="menu_area__item">
                        <img src="@/assets/seollal/save.png" v-on:click="imgSave()"/>
                    </li>
                    <li class="menu_area__item">
                        <img src="@/assets/seollal/other.png" v-on:click="gotoAnother()"/>
                    </li>
                    <li class="menu_area__item">
                        <img src="@/assets/seollal/ws.png" v-on:click="gotoWs()"/>
                    </li>
                </ul>
                <div class="third_page__bottom_img">
                    <img class="grass" src="@/assets/seollal/rabit.png"/>
                </div>
            </div>
           
        </div>
     
        
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
export default {
    name:"SeollalView",
    props : ['verse','scroll', 'page','print_verse'
            ,'goto_choice','scroll_click','share_fun','goto_another','goto_ws','image_save'],
    methods: {
        choiceVerse(){
            this.goto_choice();
            setTimeout(() => {
                this.hide=true;
            }, 5000);
            setTimeout(() => {
                this.hide=false;
            }, 10000);
        },
        scrollClick(){
            this.scroll_click();
        },
        shareClick(){
            this.share_fun();
        },
        gotoAnother(){
            this.goto_another();
        },
        gotoWs(){
            this.goto_ws();
        },
        imgSave(){
            this.image_save();
        },
        flower_init(){
            $('.third_page__flower>img').map((item)=>{
                $('.third_page__flower>img').eq(item).removeClass('on');
            })
        },
        spread_one(idx,second){
            setTimeout(() => {
                this.flower_init();
                $('.third_page__flower>img').eq(idx).addClass('on');
            }, second);
        },
        spread_flower(){
            this.spread_one(1,100);
            this.spread_one(2,150);
            this.spread_one(3,200);
            this.spread_one(4,250);
            this.spread_one(5,300);
            this.spread_one(6,350);
            this.spread_one(7,400);
            this.spread_one(8,450);
            this.spread_one(9,500);
            this.spread_one(10,550);
            this.spread_one(11,600);
            this.spread_one(12,650);
            this.spread_one(13,700);
            this.spread_one(14,750);
            this.spread_one(15,800);
            this.spread_one(16,850);
            this.spread_one(17,900);
            this.spread_one(18,950);
            this.spread_one(19,1000);
            this.spread_one(20,1050);
        }
    },
    data() {
        return {
            year : new Date().getFullYear(),
            hide : true,
           
        }
    },
    watch:{
        page(newVal){
            if(newVal==3){
                setTimeout(() => {
                    $('.third_page__pocket').addClass('on');
                }, 500);
                setTimeout(() => {
                    this.spread_flower();
                    $('.third_page__pocket').addClass('off');
                }, 700);
                setTimeout(() => {
                    $('.capture_area__verse').addClass('on');
                }, 1000);
            }
        }
    },
}
</script>
<style lang="scss" scoped>
  @import '@/assets/style/scss/seollal.scss';
</style>
